import React, { useState, useEffect } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import './List.css';
import '../App.css';

import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import LoadingComponent from '../components/LoadingComponent';
import { FileTypeListField } from '../components/filetypePage/TypeList';
import { CreateFileTypeButtonField } from '../components/filetypePage/ButtonField';

//api
import { getFileTypes } from '../apicalls/cloud/fileType';

import { Snackbar } from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { loginCheck } from '../utils/common';

export const FileTypePage: React.FC = () => {
  // ログイン状態
  const [isLogin, setIsLogin] = useState<boolean>(false);
  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useState('');
  // エラーメッセージ表示フラグ
  const [open, setOpen] = useState(false);
  // ローディング表示フラグ
  const [loading, setLoading] = useState(false);
  // 資料種別一覧
  const [fileTypes, setFileTypes] = useState<any>([]);

  const history = useHistory();

  useEffect(() => {
    console.log('初期設定');
    getAllFileTypes();
  }, []);

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  //全資料種別取得
  const getAllFileTypes = () => {
    getFileTypes().then(data => {
      if (data === 'Not logged in!') {
        <Redirect to='/' />;
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setFileTypes(data.data);
          }
        }
      }
    });
  };

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      {/* ヘッダー */}
      <AppBarComponent patternName='filetypes' />
      {/* ローディング */}
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          {/* ページタイトル */}
          <div style={{ backgroundColor: '#FFFFFF' }}>
            <div
              style={{
                fontWeight: 'bold',
                padding: 15,
                fontSize: 24
              }}
            >
              資料種別一覧
            </div>
          </div>

          {/* 新規作成ボタン */}
          <CreateFileTypeButtonField getAllFileTypes={getAllFileTypes} />
          {/* 資料種別一覧 */}
          <FileTypeListField
            fileTypes={fileTypes}
            getAllFileTypes={getAllFileTypes}
          />
        </div>
      )}
      {/* フッター */}
      <FooterComponent />
    </div>
  );
};
